import React from 'react';
import {observer} from 'mobx-react';
import {RenderV2Object} from '../render-v2-d';
import {inchToPx} from '../frame-builder';

type Props = {
    frame: RenderV2Object;
};

export const CustomItem = observer(({frame}: Props) => {
    const {customMatrix} = frame;

    return customMatrix?.flat().map((item, idx) => (
        <img
            key={idx}
            src={item.url}
            alt={item.displayType}
            style={{
                position: 'absolute',
                top: item.top !== undefined ? inchToPx(item.top) : undefined,
                bottom: item.bottom !== undefined ? inchToPx(item.bottom) : undefined,
                width: item.width === -1 ? 'auto' : inchToPx(item.width),
                height: item.height === -1 ? 'auto' : inchToPx(item.height),
            }}
        />
    ));
});
